import { useCompanyConfigQuery } from "../../../SWR/Company/useCompanyConfigQuery";
import { createKlaviyoEvent, gaEvent, gaPageView, logReactPixel, logReactPixelPageView, } from "./AnalyticsLogging-utils";
/**
 * Hook for providing analytics logging functions for Klaviyo, Google Analytics, and Facebook Pixel.
 * Selects the appropriate keys from the current company context.
 *
 */
export const useAnalyticsLogging = () => {
    const { keys, companyUsesKlaviyo } = useCompanyConfigQuery();
    const pixelKey = keys === null || keys === void 0 ? void 0 : keys.find((key) => key.KeyName === "FacebookPixelId");
    const gaKey = keys === null || keys === void 0 ? void 0 : keys.find((key) => key.KeyName === "GtagKey");
    return {
        createKlaviyoEvent: createKlaviyoEvent(companyUsesKlaviyo),
        logReactPixel: logReactPixel(pixelKey),
        logReactPixelPageView: logReactPixelPageView(pixelKey),
        gaEvent: gaEvent(gaKey),
        gaPageView: gaPageView(gaKey),
    };
};
